module.exports = __webpack_public_path__ + "img/placemakers-underconstruction-main.9d7f4db5.webp";